import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import { reportNavigationToggleExpanded, reportNavigationSetPosition } from './actions'

function mapStateToProps(state, hocProps) {
    const moduleKey = hocProps.moduleKey
    const activeReportType = state.getIn(['ui', 'modules', moduleKey, 'ribbon', 'reports', 'active'], null)
    const buttons = state.getIn(
        ['authorization', 'accessRights', moduleKey, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )

    const blocks = state.getIn(
        ['authorization', 'accessRights', moduleKey, 'custom', 'reports', activeReportType, 'blocks'],
        Map()
    )
    const sortedBlocks = blocks
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => b.get('name'))
        .toArray()

    const sortedActiveBlocks = state
        .getIn(['ui', 'modules', hocProps.moduleKey, 'ribbon', 'reportBlocks', 'data'], Map())
        .filter((val, key) => buttons.get(key))
        .filter((active) => active)
        .keySeq()
        .sort((a, b) => sortedBlocks.indexOf(a) - sortedBlocks.indexOf(b))
        .toArray()

    return {
        blocks: sortedActiveBlocks,
        expanded: state.getIn(['ui', 'modules', moduleKey, 'navigation', 'expanded']),
        position: state.getIn(['ui', 'modules', moduleKey, 'navigation', 'position']),
        maxPosition: state.getIn(['ui', 'modules', moduleKey, 'navigation', 'maxPosition']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ reportNavigationToggleExpanded, reportNavigationSetPosition }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
